import React from 'react';
import { useTranslation, initReactI18next } from "react-i18next";
import { Col, Row, Button } from "reactstrap";
import i18n from '../../../i18n';
import { Trans } from "react-i18next";
import { Page, TransparentPage, SheetOfPaper } from "../../../components/Page/Page";
import Chapter from "../../../components/Chapter/Chapter";
import SourceHeader from "../../../components/SourceHeader/SourceHeader";

import routes from './c02_routes.js';
import ENTranscriptPDF from './Transcripts/en/en_c2_p5.pdf';
import NOTranscriptPDF from './Transcripts/no/no_c2_p5.pdf';
import DocumentIMG from './Media/c2_p5.jpg';

const C02P05 = (props) => {
	const { t } = useTranslation();
	const translation_namespace = 'c02_p05';

	return (
		<Chapter pages={routes} chapterName={props.chapterName} currentPageYear={props.year}>
			<Page className="C02P05">
				<TransparentPage>
					<img src={ DocumentIMG } alt={ t('Image of the original document transcribed next') } />
					<ul className="download-links">
						<li><a href={ i18n.language === 'nb-NO' ? NOTranscriptPDF : ENTranscriptPDF } target="_blank"><Trans>Download</Trans> pdf <Trans>file</Trans></a></li>
						<li><a href={DocumentIMG} target="_blank"><Trans>Download</Trans> <Trans>image file</Trans></a></li>
					</ul>
				</TransparentPage>
				<SheetOfPaper>
					<SourceHeader name={ props.name } chapterName={ props.chapterName } />
					<p>
						<strong><Trans ns={ translation_namespace }>Letter from rabbi Julius Samuel in Oslo to the board of the Jewish Community in Trondheim, dated December 22nd, 1941. The Jewish Museum in Trondheim.</Trans></strong>
					</p>
					<h2><Trans>Transcript</Trans>:</h2>
					<div className="transcript">
						<p>
							<Trans>Rabbi</Trans><br />
							Julius Samuel<br />
							<Trans>The Jewish Community</Trans>
						</p>
						<p>
							<Trans ns={ translation_namespace }>Oslo, December 22nd, 1941</Trans>
						</p>
						<p>
							<Trans>To</Trans><br />
							<Trans ns={ translation_namespace }>The Board of The Jewish Community in Trondheim</Trans>
						</p>
						<p>
							<Trans ns={ translation_namespace }>I hereby permit myself to inform you that your current employee, Mr. Cantor J. Grabowski today has had a Hebrew documentation (Kabbalah) rendered after satisfying the requirements we made on him.
</Trans>
						</p>
						<p>
							<Trans>Yours faithfully</Trans><br />
							Rab. J. Samuel
						</p>
					</div>
				</SheetOfPaper>
			</Page>
		</Chapter>
	);
};

export default C02P05;